import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import MarkdownEditorController from "./controllers/markdown_editor_controller"
import ImageUploadController from "./controllers/image_upload_controller"
import SeoKeywordsController from "./controllers/seo_keywords_controller"
import FileDropController from "./controllers/file_drop_controller"
import OutlineSortController from "./controllers/outline_sort_controller"
import ChainOtherController from "./controllers/chain_other_controller"

const application = Application.start()
application.register("markdown-editor", MarkdownEditorController)
application.register("image-upload", ImageUploadController)
application.register("seo-keywords", SeoKeywordsController)
application.register("file-drop", FileDropController)
application.register("outline-sort", OutlineSortController)
application.register("chain-other", ChainOtherController)
